import { brandMarkColors, brandMarkSvg, } from '../brand-mark';
import { webDesignLight } from './renkler';
/**
 * WEB LOGOSU RENKLERİ (Logo kartı, renk ailesi L20, 30.10.2026).
 *
 * "Koyu mor kare, beyaz W, fıstık onay. İşaret başka renge boyanmaz … Açık
 * zeminde, `surface` üstünde ve `band` üstünde aynen kullanılır." Bu yüzden
 * kareli üç varyant (açık, bant, koyu tema) AYNI üç rengi taşır; değerler açık
 * tema web renklerinden. Geometri `brand-mark.ts`ten aynen gelir.
 * `brand-mark.ts`in renk tablosu eski tonu taşır ve DONMUŞTUR (M-1). Mobil işaret,
 * uygulama simgesi ve açılış ekranı yeni renkleri `mobileBrandMarkColors`tan alır
 * (31.10.2026). Bu dosya `web-tema` altındadır; mobil buradan okumaz
 * (`mobil-web-tema-siniri.guard.spec.ts`).
 */
const WEB_LOGO = {
    square: webDesignLight.primary,
    mark: webDesignLight.textOnPrimary,
    accent: webDesignLight.accent,
};
export const webBrandMarkColors = {
    light: WEB_LOGO,
    dark: WEB_LOGO,
    darkTheme: WEB_LOGO,
    mono: brandMarkColors.mono,
};
/**
 * `brandMarkSvg` ile aynı dize; kare, W ve onay kolu web logosunun renkleriyle
 * çizilir. Değiştirme tek geçişte yapılır: bir rengin yenisi başka bir rolün
 * eskisine denk gelse de ikinci kez boyanmaz.
 */
export function webBrandMarkSvg(options) {
    const svg = brandMarkSvg(options);
    const from = brandMarkColors[options.variant];
    const to = webBrandMarkColors[options.variant];
    const swap = new Map();
    for (const role of ['square', 'mark', 'accent']) {
        const before = from[role];
        const after = to[role];
        if (before && after && before !== after)
            swap.set(`"${before}"`, `"${after}"`);
    }
    return swap.size === 0 ? svg : svg.replace(/"#[0-9A-Fa-f]{3,8}"/g, (hex) => swap.get(hex) ?? hex);
}
//# sourceMappingURL=logo.js.map